import { render, staticRenderFns } from "./changesticker.vue?vue&type=template&id=5f26bbe3&"
import script from "./changesticker.vue?vue&type=script&lang=js&"
export * from "./changesticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports